export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfCBc4AMP6lbBP.102fc503.woff2";